<template>
  <transition name="map-detail">
    <article class="page-map" id="page-map" v-show="mapShow">

        <div class="page-body">
          <div id="map" style="display: block; height: 450px; margin: 0"></div>

          <!--<a-skeleton v-show="loading" active :title="false" />-->
          <div class="storeInfo-col">
            <h4>{{ storeName }}</h4>
            <div class="preview-grid addressCol">
            	<div class="title-icon">
            		<a-icon type="environment" theme="twoTone" two-tone-color="#0f894d"/>
            	</div>
            	<div class="address-col" v-html="address"></div>
            </div>
          </div>
        </div>

        <div class="map-button-col">
        	<button type="button" class="btn btn-warning" @click="backClick">Back</button>
        </div>
      </article>


  </transition>
</template>

<script>
import { Google } from "@/utils/importGoogle";
import axios from 'axios';

export default {
  name: "Map",

  data () {
    return {
      lat: '',
      lng: '',
      loc_lat: '',
      loc_lng: '',

    };
  },
  props:[
      "storeLogo","storeName","address", "locationLat",'mapShow','locationLng'
    ],

  created () {
     this.lat = this.locationLat
     this.lng = this.locationLng
   },

  computed: {

  },
  methods: {


    backClick () {
      this.$emit('update:mapShow', false)
    },
    initMap () {
      Google().then((google) => {
        var map = new google.maps.Map(document.getElementById("map"), {
          zoom: 14,
          scrollwheel: false,
          center: new google.maps.LatLng(
            parseFloat(this.locationLat),
            parseFloat(this.locationLng)
          ),
          mapTypeId: google.maps.MapTypeId.ROADMAP,
        });

        var marker, i;
        var markers = new Array();
        marker = new google.maps.Marker({
          position: new google.maps.LatLng(
            parseFloat(this.locationLat),
            parseFloat(this.locationLng)
          ),
          map: map,
        });
        this.lat = Number(this.locationLat)
        this.lng = Number(this.locationLng)
        var cityCircle = new google.maps.Circle({
          strokeColor: "#FF955D",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: "#FF955D",
          fillOpacity: 0.35,
          map: map,
          center: { lat: this.lat, lng: this.lng },
          radius: 500,
        });
      });
    },
  },

  mounted () {
    this.initMap();

  },
};
</script>

<style scoped="scoped">
.map-detail-enter-active,
.map-detail-leave-active {
  transition: 0.5s;
}

.map-detail-enter,
.map-detail-leave-to {
  transform: translateX(100%);
}

.locAddress-col * {
  font-size: 14px;
}
.locAddress-col h6 {
  font-size: 12px;
  text-transform: uppercase;
}
.locAddress-col {
  padding: 15px 20px 5px;
  text-align: left;
  border-bottom: 1px solid #dedede;
  position: relative;
  min-height: 50px;
  display: grid;
  grid-template-columns: 1fr 80px;
  grid-auto-flow: dense;
  grid-column-gap: 10px;
}
.address_tag {
  margin: -5px 0 10px;
}
.address_tag span {
  font-size: 12px;
  padding: 5px 10px;
  border-radius: 3px;
  border: 1px solid #ff955d;
  color: #ff955d;
}
</style>



// WEBPACK FOOTER //
// src/components/Map.vue